import moment from 'moment';
import FormReport from "../FormList/FormReport";
import React, { useEffect, useRef, useState } from 'react'
import { Badge, Form, Spinner, Table } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';
import { studyOtherSettingsServices } from '../../../../APIServices/studyOtherSettingsServices';
import { useParams } from 'react-router';
import UseToggle from '../../../../Hooks/UseToggle';
import FormReview from '../FormList/FormReview';
import { formReportServices } from '../../../../APIServices/formReportServices';

const FormDataEntryReport = ({
    buttonUnscheduledFormLoader,
    softDeleteRestoreStudySubjectEventUnscheduledForm,
    repeatConditionalButtonLoader,
    repeatStudySubjectEventConditinalForm,
    setToggle9,
    connectedConditionalFormList,
    dataRecordId,
    connectedFormFieldList,
    connectedFormFieldLoader,
    handleAddNewTab,
    formName,
    formType,
    recordNumber,
    StudyMode,
    studyPermission,
    activeTabName,
    formRepeat,
    repeatNumber,
    totalDataEntry,
    repeatButtonLoader,
    repeatStudySubjectEventForm,
    saveButtonLoader,
    addNewStudySubjectDataEntry,
    setToggle4,
    formFields,
    totalOptionId,
    valueRanderFunction,
    handleNumberChange,
    handleCustomNumberChange,
    handleTextChange,
    handleCustomTextChange,
    handleDateChange,
    handleCustomDateChange,
    handleTimeChange,
    handleCustomTimeChange,
    handleTextareaChange,
    handleDropdownRadioChange,
    handleCustomDropdownRadioChange,
    handleRangeScoreChange,
    handleScaleChange,
    fileUploadLoader,
    handleUploadChange,
    handleCheckboxChange,
    handleCustomCheckboxChange,
    convertTo24,
    setToggle3,
    setFieldId,
    setFieldLabel,
    setToggle5,
    getStudySubjectFormFreezeUnfreezeHistoryDataEntry,
    getStudySubjectFormFieldReviewHistoryDataEntry,
    getStudyDataEntryFieldUpdatedHistoryList,
    dataEntryFormReviewHistory,
    dataEntryFormReviewHistoryLoader,
    formId,
    setToggle6,
    getStudySubjectFormReviewDataEntryList,
    version,
    entryType,
    editField,
    recordId,
    handleCheckboxEditFieldChange
}) => {
    const GeneratedDate = moment(new Date()).format("DD-MMM-YYYY | HH:mm:ss");
    let { studyId } = useParams();
    const [errorValidation, setErrorValidation] = useState(false)
    const [reportHeaders, setReportHeaders] = useState([]);
    const [reportFooters, setReportFooters] = useState([]);
    const [reportLogo, setReportLogo] = useState("");
    const componentRef = useRef();
    const { toggle, setToggle } = UseToggle();
    const getReportStudyMetadataData = async () => {
        let data = await formReportServices.getReportStudyMetadataData(studyId)
        let reportData = data?.data || []
        let headerData = reportData?.find(item => item.type === "header")?.headerData || []
        let footerData = reportData?.find(item => item.type === "footer")?.footerData || []
        let logoData = reportData?.find(item => item.type === "logo")
        setReportHeaders(headerData)
        setReportFooters(footerData)
        setReportLogo(logoData)
    }

    useEffect(() => {
        getReportStudyMetadataData();
    }, []);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `${formName} Report`,
    });

    const [isAdvance, setIsAdvance] = useState(false);
    const hasNotAssignedSDVUsers = dataEntryFormReviewHistory?.length === 0 || dataEntryFormReviewHistory?.some(item => item.users?.length === 0);
    const hasOpenQuery = totalDataEntry?.some(
        (item) =>
            item?.queryStatus === "open" ||
            item?.queryNotifyStatus === "open"
    );

    const checkDataEntryHasValue = () => {
        const changableVariables = [
            "value",
            "unit",
            "unitType",
            "referenceRangeLowerLimit",
            "referenceRangeLowerLimitEntryType",
            "referenceRangeUpperLimit",
            "referenceRangeUpperLimitEntryType",
            "referenceRangeIndicator",
            "clinicalSignificance",
            "remark",
            "day",
            "month",
            "year",
            "hour",
            "minute",
            "second",
            "format",
            "valueRemark",
        ];
        const hasValue = (value) => {
            if (Array.isArray(value)) return value.length > 0;
            return (
                value !== null &&
                value !== undefined &&
                value !== ""
            );
        };
        const isDataPresent = totalDataEntry.some((item) =>
            changableVariables.some((key) => hasValue(item?.[key]))
        );
        return !isDataPresent;
    };

    useEffect(() => {
        if (totalDataEntry?.length > 0) {
            checkDataEntryHasValue();
        }
    }, [totalDataEntry?.length]);

    return (
        <>
            <div className="border-bottom p-2 bg-light">
                <div className="hstack justify-content-between" style={{ height: 40 }}>
                    <div className="mb-0">
                        <div className='hstack'>
                            <i className="fa-solid fa-file-prescription me-2"></i>
                            <h6 className='fw-bold m-0'>{formName}</h6>
                        </div>
                        <div className='hstack'>
                            <Form.Switch
                                size="sm"
                                checked={isAdvance}
                                onChange={(e) => setIsAdvance(e.target.checked)}
                                className="thin-toggle"
                                style={{ paddingTop: 6 }}
                            />
                            <Form.Text className='m-0' style={{ fontSize: '11px' }}>
                                {!isAdvance ? 'Regular' : 'Advance'}
                            </Form.Text>
                        </div>
                    </div>
                    <div className="hstack gap-2">
                        {(StudyMode === "DBP Mode" || studyPermission?.qcPrintReport || studyPermission?.livePrintReport || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
                            <button
                                onClick={handlePrint}
                                className={`updateProfile`}
                                title="Print Form"
                            >
                                <span>Print</span>
                            </button>
                        }
                        {(!(StudyMode?.startsWith("SDV")) && activeTabName?.type === "unscheduledForm") &&
                            <button
                                className={`removeProfile`}
                                title="Delete Form"
                                disabled={buttonUnscheduledFormLoader}
                                onClick={() => softDeleteRestoreStudySubjectEventUnscheduledForm("delete")}
                            >
                                <span>
                                    {buttonUnscheduledFormLoader ? (
                                        <div className='hstack gap-2'>
                                            <Spinner size="sm" /> Deleting...
                                        </div>
                                    ) : (
                                        "Delete Form"
                                    )}
                                </span>
                            </button>
                        }
                        {connectedConditionalFormList?.length > 0 && (recordId || dataRecordId) &&
                            <button
                                disabled={!dataRecordId}
                                onClick={setToggle9}
                                className={`updateProfile`}
                                title="Connect this Form"
                            >
                                <span>Connect this Form</span>
                            </button>
                        }
                        {((StudyMode === "DBP Mode" || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) && !(StudyMode?.startsWith("SDV")) && activeTabName?.viewType === "dataEntry") &&
                            <>
                                {formRepeat === "yes" && repeatNumber === 0 &&
                                    <button
                                        disabled={!dataRecordId || repeatButtonLoader}
                                        onClick={repeatStudySubjectEventForm}
                                        className={`updateProfile`}
                                        title="Repeat Form"
                                    >
                                        <span>
                                            {repeatButtonLoader ? (
                                                <div className='hstack gap-2'>
                                                    <Spinner size="sm" /> Repeating...
                                                </div>
                                            ) : (
                                                "Repeat Form"
                                            )}
                                        </span>
                                    </button>
                                }
                                <button
                                    disabled={fileUploadLoader || checkDataEntryHasValue() || errorValidation || saveButtonLoader}
                                    onClick={() => addNewStudySubjectDataEntry()}
                                    className={`updateProfile`}
                                    title="Save Data Entry"
                                >
                                    <span>
                                        {saveButtonLoader ? (
                                            <div className='hstack gap-2'>
                                                <Spinner size="sm" /> Saving...
                                            </div>
                                        ) : (
                                            "Save Data Entry"
                                        )}
                                    </span>
                                </button>
                            </>
                        }
                        {activeTabName?.viewType === "dataEntry" && (StudyMode?.startsWith("SDV") || StudyMode === "DBP Mode") &&
                            <button
                                disabled={!dataRecordId || hasNotAssignedSDVUsers || hasOpenQuery}
                                onClick={() => setToggle4()}
                                className={`updateProfile`}
                                title="SDV All Field"
                            >
                                <span>SDV All Field</span>
                            </button>
                        }
                    </div>
                </div>
            </div >
            <div className="overflow-auto" style={{ height: "calc(100vh - 201px)" }}>
                <div ref={componentRef}>
                    <Table className="m-0">
                        {/* <thead className="position-sticky top-0 z-1">
                            <tr>
                                <th className="p-0 border-0">
                                    <div className="crfHeader headPrint">
                                        <div className="crfTop hstack justify-content-between text-white">
                                            <div className="gap-3 hstack">
                                                <img src={reportLogo?.logo || "https://www.largeherds.co.za/wp-content/uploads/2024/01/logo-placeholder-image.png"} alt="Company Logo" style={{ width: reportLogo?.width || 80, height: reportLogo?.height || 80 }} />  
                                                <div>
                                                    {reportHeaders?.length > 0 && reportHeaders?.map((item, index) => ( <p key={index} className="m-0 fw-bold" style={{ fontSize: 12 }}>{item?.text}</p> ))}
                                                    <p className="m-0 fw-bold">{formName}</p> <small className="m-0">SDTM LB-aligned eCRF · Electronic Case Report Form</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="crfInfoRow d-grid">
                                            <div className="crfCell">
                                                <small className="m-0 text-white opacity-75" style={{ fontSize: 11 }}>FORM ID</small>

                                                <p className="m-0 fw-bold text-white" style={{ fontSize: 12 }}>CRF-LB-01</p>
                                            </div>

                                            <div className="crfCell">
                                                <small className="m-0 text-white opacity-75" style={{ fontSize: 11 }}>VERSION</small>

                                               <p className="m-0 fw-bold text-white" style={{ fontSize: 12 }}>V.{version}</p>
                                            </div>

                                            <div className="crfCell">
                                                <small className="m-0 text-white opacity-75" style={{ fontSize: 11 }}>Generated On:</small>

                                                <p className="m-0 fw-bold text-white" style={{ fontSize: 12 }}>{GeneratedDate}</p>
                                            </div>
                                        </div>
                                        <div className="crfInfoRow light d-grid">

                                            <div className="crfCell">
                                                <small className="m-0 text-muted">SITE</small>

                                                <p className="m-0 fw-bold" style={{ fontSize: 12 }}>{activeTabName?.siteName || '-'}</p>
                                            </div>

                                            <div className="crfCell">
                                                <small className="m-0 text-muted">SUBJECT</small>

                                               <p className="m-0 fw-bold" style={{ fontSize: 12 }}>{activeTabName?.subjectName || '-'}</p>
                                            </div>

                                            <div className="crfCell">
                                                <small className="m-0 text-muted">VISIT</small>

                                                <p className="m-0 fw-bold" style={{ fontSize: 12 }}>{activeTabName?.eventName || '-'}</p>
                                            </div>

                                        </div>

                                    </div>
                                </th>
                            </tr>
                        </thead> */}
                        <thead className="position-sticky top-0 z-1">
                            <div className="headPrint">
                                <div className="hstack justify-content-between py-3">
                                    <div>
                                        {reportHeaders?.length > 0 && reportHeaders?.map((item, index) => (
                                            <p key={index} className="m-0 fw-bold" style={{ fontSize: 12 }}>{item?.text}</p>
                                        ))}
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Form Name: {formName}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Form Version: V{version}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Site: {activeTabName?.siteName}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Subject: {activeTabName?.subjectName}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Event: {activeTabName?.eventName} {activeTabName?.timePointLabel && `(${activeTabName?.timePointLabel})`}</p>
                                        <p className="m-0 fw-bold" style={{ fontSize: 12 }}>Generated On: {GeneratedDate}</p>
                                    </div>
                                    <img src={reportLogo?.logo || ""} alt="Company Logo" style={{ width: reportLogo?.width || 150, height: reportLogo?.height || 80 }} />
                                </div>
                            </div>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="border-0 p-0">
                                    <FormReport
                                        repeatConditionalButtonLoader={repeatConditionalButtonLoader}
                                        repeatStudySubjectEventConditinalForm={repeatStudySubjectEventConditinalForm}
                                        connectedFormFieldList={connectedFormFieldList}
                                        connectedFormFieldLoader={connectedFormFieldLoader}
                                        handleAddNewTab={handleAddNewTab}
                                        activeTabName={activeTabName}
                                        formType={formType}
                                        emptyDataEntry={totalDataEntry?.length === 0}
                                        formFields={formFields}
                                        totalOptionId={totalOptionId}
                                        setErrorValidation={setErrorValidation}
                                        valueRanderFunction={valueRanderFunction}
                                        handleNumberChange={handleNumberChange}
                                        handleCustomNumberChange={handleCustomNumberChange}
                                        handleTextChange={handleTextChange}
                                        handleCustomTextChange={handleCustomTextChange}
                                        handleDateChange={handleDateChange}
                                        handleCustomDateChange={handleCustomDateChange}
                                        handleTimeChange={handleTimeChange}
                                        handleCustomTimeChange={handleCustomTimeChange}
                                        handleTextareaChange={handleTextareaChange}
                                        handleDropdownRadioChange={handleDropdownRadioChange}
                                        handleCustomDropdownRadioChange={handleCustomDropdownRadioChange}
                                        handleRangeScoreChange={handleRangeScoreChange}
                                        handleScaleChange={handleScaleChange}
                                        fileUploadLoader={fileUploadLoader}
                                        handleUploadChange={handleUploadChange}
                                        handleCheckboxChange={handleCheckboxChange}
                                        handleCustomCheckboxChange={handleCustomCheckboxChange}
                                        convertTo24={convertTo24}
                                        mode={StudyMode}
                                        studyPermission={studyPermission}
                                        enableDataEntry={(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly) ? "" : activeTabName?.viewType === "dataEntry"}
                                        setFieldId={setFieldId}
                                        setFieldLabel={setFieldLabel}
                                        setToggle3={setToggle3}
                                        setToggle5={setToggle5}
                                        getStudySubjectFormFreezeUnfreezeHistoryDataEntry={getStudySubjectFormFreezeUnfreezeHistoryDataEntry}
                                        getStudySubjectFormFieldReviewHistoryDataEntry={getStudySubjectFormFieldReviewHistoryDataEntry}
                                        getStudyDataEntryFieldUpdatedHistoryList={getStudyDataEntryFieldUpdatedHistoryList}
                                        dataEntryFormReviewHistory={dataEntryFormReviewHistory}
                                        dataEntryFormReviewHistoryLoader={dataEntryFormReviewHistoryLoader}
                                        formId={formId}
                                        version={version}
                                        recordId={recordId}
                                        entryType={entryType}
                                        setToggle={setToggle}
                                        setToggle6={setToggle6}
                                        getStudySubjectFormReviewDataEntryList={getStudySubjectFormReviewDataEntryList}
                                        handleCheckboxEditFieldChange={handleCheckboxEditFieldChange}
                                        editField={editField}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
            <FormReview
                Show={!toggle}
                Hide={setToggle}
                formId={formId}
                Title={`${formName}`}
            />
        </>
    )
}

export default FormDataEntryReport
